/**
 * Fixed pin colors for the SRE possible identifications. They replace the status color
 * (red for pending, green for completed) on the map: there is no pending/completed variation
 * for these categories.
 *
 * Keys are the values stored on `possibleIdentification`. The apps save the OTHER_POSSIBLE_*
 * form; the POSSIBLE_* and bare forms are accepted too. Aircraft wreckage and Other can't be
 * picked yet, so both naming forms are accepted for them.
 */
const SRE_PIN_COLOR_BY_KEY: Record<string, string> = {
  OTHER_POSSIBLE_OSSEOUS_MATERIAL: '#AA336A',
  POSSIBLE_OSSEOUS_MATERIAL: '#AA336A',

  OTHER_POSSIBLE_MATERIAL_EVIDENCE: '#0000FF',
  POSSIBLE_MATERIAL_EVIDENCE: '#0000FF',

  OTHER_POSSIBLE_LIFE_SUPPORT_EQUIPMENT: '#CD7F32',
  POSSIBLE_LIFE_SUPPORT_EQUIPMENT: '#CD7F32',

  OTHER_POSSIBLE_AIRCRAFT_WRECKAGE: '#00BCD4',
  POSSIBLE_AIRCRAFT_WRECKAGE: '#00BCD4',
  AIRCRAFT_WRECKAGE: '#00BCD4',

  OTHER: '#BF40BF',
  POSSIBLE_OTHER: '#BF40BF',
  OTHER_POSSIBLE_OTHER: '#BF40BF',
};

/**
 * The pin color for a report's SRE category, or null when none of its possible identifications is
 * one (a UXO report), in which case the pin keeps its status color.
 *
 * When several SRE categories are present the first one in the report's identification list wins,
 * and an SRE category also wins over any UXO identification on the same report.
 */
export function sreCategoryPinColor(possibleIdentification: string[] | string | null | undefined): string | null {
  const keys = Array.isArray(possibleIdentification) ? possibleIdentification : [possibleIdentification];

  for (const key of keys) {
    const color = key ? SRE_PIN_COLOR_BY_KEY[String(key).trim().toUpperCase()] : undefined;
    if (color) {
      return color;
    }
  }

  return null;
}
